import {
  coverUrlFromManifest,
  DEFAULT_COVER_IMAGE_URL,
} from "./coverImage.js";

/**
 * Loads a product cover from the first SKU's asset manifest.
 * Host components must provide `firstSkuId`.
 */
export default {
  data() {
    return {
      coverUrl: DEFAULT_COVER_IMAGE_URL,
      brokenCover: false,
      coverFetchGeneration: 0,
    };
  },
  watch: {
    firstSkuId: {
      immediate: true,
      handler(skuId) {
        this.loadManifestCover(skuId);
      },
    },
  },
  methods: {
    async loadManifestCover(skuId) {
      const generation = ++this.coverFetchGeneration;
      this.brokenCover = false;
      this.coverUrl = DEFAULT_COVER_IMAGE_URL;
      const url = await coverUrlFromManifest(skuId);
      if (generation !== this.coverFetchGeneration || this.brokenCover) {
        return;
      }
      this.coverUrl = url;
    },
    useDefaultCover(event) {
      this.brokenCover = true;
      this.coverUrl = DEFAULT_COVER_IMAGE_URL;
      if (event?.target && event.target.src !== DEFAULT_COVER_IMAGE_URL) {
        event.target.src = DEFAULT_COVER_IMAGE_URL;
      }
    },
  },
};
